import { useEffect } from 'react';

import { Card, CardBody, CardTitle, CardText } from 'reactstrap';

import '../styles/ServiceCard.css';
import Aos from 'aos';
import 'aos/dist/aos.css';

const ServiceCard = ({ icon, title, text }) => {

    // Initialize AOS for animations
    useEffect(() => {
        Aos.init({ duration: 1000, once: true });
    }, []);

    return (
            <Card className='service-card' data-aos="fade-in">
                <img
                    alt="Service Icon"
                    src={icon}
                    className='service-card-icon'
                />
                <CardBody className='service-card-body'>
                    <CardTitle className='service-card-title' tag="h5">
                        {title}
                    </CardTitle>
                    <CardText className='service-card-text'>
                        {text}
                    </CardText>
                </CardBody>
            </Card>
        );
}
export default ServiceCard;